import React from 'react';
import { useNavigate } from 'react-router-dom';

const MONO = "'JetBrains Mono', monospace";
const LABEL_STYLE = { fontSize: 13, fontFamily: MONO, letterSpacing: '0.06em', color: 'rgba(var(--brand-primary-rgb),0.4)', marginBottom: 8 };
const BODY_STYLE = { fontSize: 14, lineHeight: 1.9, color: 'rgba(185,202,203,0.8)' };
const HEADING_STYLE = { fontSize: 15, lineHeight: 1.8, color: '#c8d0d1', marginBottom: 8 };

function Section({ label, children }) {
  return (
    <section style={{ marginBottom: 36 }}>
      <p style={LABEL_STYLE}>{label}</p>
      {children}
    </section>
  );
}

function Datenschutz() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#080a0e', color: '#e2e2e8', fontFamily: "var(--font-display)", padding: '48px 24px' }}>
      <div style={{ maxWidth: 680, margin: '0 auto' }}>

        {/* Back */}
        <button
          onClick={() => navigate(-1)}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontFamily: MONO, fontSize: 11, letterSpacing: '0.12em', color: 'rgba(var(--brand-primary-rgb),0.65)', background: 'none', border: 'none', cursor: 'pointer', marginBottom: 48, padding: 0 }}
          onMouseEnter={e => e.currentTarget.style.color = 'var(--brand-primary)'}
          onMouseLeave={e => e.currentTarget.style.color = 'rgba(var(--brand-primary-rgb),0.65)'}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="square">
            <polyline points="15,18 9,12 15,6" />
          </svg>
          ZURÜCK
        </button>

        <h1 style={{ fontFamily: MONO, fontSize: 12, fontWeight: 700, letterSpacing: '0.2em', color: 'var(--brand-primary)', margin: '0 0 40px 0' }}>
          DATENSCHUTZERKLÄRUNG
        </h1>

        {/* 1. Verantwortlicher */}
        <Section label="1. VERANTWORTLICHER (ART. 13 DSGVO)">
          <p style={HEADING_STYLE}>
            Martin Schramm<br />
            Brückenstr. 14<br />
            53474 Ahrweiler<br />
            Deutschland<br />
            E-Mail: <a href="mailto:martin@critroster.cc" style={{ color: 'var(--brand-primary)', textDecoration: 'none' }}>martin@critroster.cc</a>
          </p>
        </Section>

        {/* 2. Welche Daten */}
        <Section label="2. VERARBEITETE PERSONENBEZOGENE DATEN">
          <p style={BODY_STYLE}>
            Im Rahmen der Nutzung von Crit Roster werden folgende personenbezogene Daten verarbeitet,
            die du bei der Registrierung oder im Nachhinein im Profil angibst:
          </p>
          <ul style={{ ...BODY_STYLE, paddingLeft: 20, marginTop: 12 }}>
            <li>Vor- und Nachname</li>
            <li>E-Mail-Adresse</li>
            <li>Geburtsdatum</li>
            <li>Telefonnummer</li>
            <li>Postanschrift</li>
            <li>Profilfoto</li>
            <li>Lizenznummer / UCI-ID</li>
          </ul>
        </Section>

        {/* 3. Zweck & Rechtsgrundlage */}
        <Section label="3. ZWECK DER VERARBEITUNG UND RECHTSGRUNDLAGE">
          <p style={BODY_STYLE}>
            Die Daten werden ausschließlich zum Betrieb der Plattform Crit Roster verarbeitet –
            insbesondere zur Verwaltung von Fahrerkonten, Teamzugehörigkeiten und Rennveranstaltungen.
          </p>
          <p style={{ ...BODY_STYLE, marginTop: 12 }}>
            Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung bzw. vorvertragliche Maßnahmen),
            soweit die Daten für die Bereitstellung des Dienstes erforderlich sind, sowie Art. 6 Abs. 1 lit. a DSGVO
            (Einwilligung) für freiwillig angegebene Informationen wie Profilfoto und Telefonnummer.
          </p>
        </Section>

        {/* 4. Speicherdauer */}
        <Section label="4. SPEICHERDAUER">
          <p style={BODY_STYLE}>
            Deine Daten werden gespeichert, solange dein Konto aktiv ist. Nach einer Kontoauflösung
            werden die Daten innerhalb von 30 Tagen gelöscht, sofern keine gesetzlichen
            Aufbewahrungspflichten entgegenstehen.
          </p>
        </Section>

        {/* 5. Hosting */}
        <Section label="5. HOSTING UND TECHNISCHER BETRIEB">
          <p style={BODY_STYLE}>
            Die App wird auf Servern von Render Services, Inc. (San Francisco, CA, USA) betrieben.
            Render verarbeitet Daten im Auftrag des Verantwortlichen auf Grundlage eines
            Datenverarbeitungsvertrags (DPA) gemäß Art. 28 DSGVO. Die Server befinden sich in der EU (Frankfurt).
            Näheres unter <a href="https://render.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--brand-primary)', textDecoration: 'none' }}>render.com/privacy</a>.
          </p>
        </Section>

        {/* 6. Weitergabe */}
        <Section label="6. WEITERGABE AN DRITTE">
          <p style={BODY_STYLE}>
            Eine Weitergabe deiner Daten an Dritte findet grundsätzlich nicht statt. Ausgenommen sind
            technische Dienstleister (Hosting, s. Punkt 5), die die Daten ausschließlich weisungsgebunden
            verarbeiten, sowie gesetzlich vorgeschriebene Auskunftspflichten gegenüber Behörden.
          </p>
        </Section>

        {/* 7. Cookies */}
        <Section label="7. COOKIES UND TRACKING">
          <p style={BODY_STYLE}>
            Crit Roster verwendet keine Tracking-Cookies und keine Analysetools von Drittanbietern.
            Es wird lediglich ein technisch notwendiges Session-Token (JWT) im Local Storage des Browsers
            gespeichert, um dich angemeldet zu halten. Dieses Token enthält keine personenbezogenen Daten
            außer einer internen Nutzer-ID.
          </p>
        </Section>

        {/* 8. Rechte */}
        <Section label="8. DEINE RECHTE ALS BETROFFENE PERSON">
          <p style={BODY_STYLE}>
            Du hast gegenüber dem Verantwortlichen folgende Rechte gemäß DSGVO:
          </p>
          <ul style={{ ...BODY_STYLE, paddingLeft: 20, marginTop: 12 }}>
            <li><strong style={{ color: '#c8d0d1' }}>Auskunft</strong> (Art. 15) – welche Daten über dich gespeichert sind</li>
            <li><strong style={{ color: '#c8d0d1' }}>Berichtigung</strong> (Art. 16) – Korrektur unrichtiger Daten</li>
            <li><strong style={{ color: '#c8d0d1' }}>Löschung</strong> (Art. 17) – Löschen deiner Daten</li>
            <li><strong style={{ color: '#c8d0d1' }}>Einschränkung der Verarbeitung</strong> (Art. 18)</li>
            <li><strong style={{ color: '#c8d0d1' }}>Datenübertragbarkeit</strong> (Art. 20)</li>
            <li><strong style={{ color: '#c8d0d1' }}>Widerspruch</strong> (Art. 21) – gegen die Verarbeitung</li>
            <li><strong style={{ color: '#c8d0d1' }}>Widerruf einer Einwilligung</strong> (Art. 7 Abs. 3) – jederzeit mit Wirkung für die Zukunft</li>
          </ul>
          <p style={{ ...BODY_STYLE, marginTop: 12 }}>
            Zur Ausübung deiner Rechte wende dich per E-Mail an{' '}
            <a href="mailto:martin@critroster.cc" style={{ color: 'var(--brand-primary)', textDecoration: 'none' }}>martin@critroster.cc</a>.
          </p>
        </Section>

        {/* 9. Beschwerde */}
        <Section label="9. BESCHWERDERECHT BEI EINER AUFSICHTSBEHÖRDE">
          <p style={BODY_STYLE}>
            Du hast das Recht, dich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung deiner
            Daten zu beschweren. Zuständige Behörde für Rheinland-Pfalz ist der{' '}
            <a href="https://www.datenschutz.rlp.de" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--brand-primary)', textDecoration: 'none' }}>
              Landesbeauftragte für den Datenschutz und die Informationsfreiheit Rheinland-Pfalz
            </a>.
          </p>
        </Section>

        {/* Footer line */}
        <div style={{ marginTop: 48, paddingTop: 24, borderTop: '1px solid rgba(var(--brand-primary-rgb),0.1)', fontFamily: MONO, fontSize: 9, color: 'rgba(var(--brand-primary-rgb),0.25)', letterSpacing: '0.08em' }}>
          CRIT ROSTER — CRITROSTER.CC · STAND: SEPTEMBER 2026
        </div>

      </div>
    </div>
  );
}

export default Datenschutz;
